'use client'

import AspectRatioCover from '@comp/AspectRatioCover'
import useLogin from '@hook/useLogin'
import clsx from 'clsx'

export default function ChatRow({ data }) {
  const { user, isLogin } = useLogin()
  const isMe = isLogin && user && user.id === data.user.id

  return (
    <div className={clsx('flex items-start gap-x-pix-20', { 'flex-row-reverse': isMe })}>
      <div className="h-pix-40 w-pix-40">
        <AspectRatioCover
          width={40}
          height={40}
          src={data.user.avatar}
          alt={data.user.nickname}
          className="rounded-full"
        />
      </div>
      <div className={clsx('flex min-w-0 flex-1', isMe ? 'justify-end' : 'justify-start')}>
        <div
          className={clsx(
            'relative inline-block break-words rounded-sm p-pix-10 text-f.7',
            isMe ? 'bg-primary text-white' : 'bg-cf8'
          )}
          style={{ wordBreak: 'break-word' }}
        >
          <i
            className={clsx(
              'absolute top-pix-10 border-[10px] border-transparent',
              isMe
                ? 'right-0 translate-x-full border-l-primary'
                : 'left-0 -translate-x-full border-r-cf8'
            )}
          />
          <span
            className={clsx(
              'mr-pix-4 whitespace-nowrap font-bold',
              isMe ? 'text-white' : 'text-primary'
            )}
          >
            {data.user.nickname}
            :
          </span>
          {data.message}
        </div>
      </div>
    </div>
  )
}
